/** @format */

import { Tag, Loading } from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import { BG_COLORS, STATUSES_UP, IS_PUBLISHED } from "../../utils/constants";
import { getAccount } from "../../redux/actions/accountAction";
import {
  bulkDeleteProject,
  fetchAllProject,
} from "../../redux/actions/projectAction";
import { debounce } from "lodash";

function ProjectPage() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoadingData, setIsLoadingData] = useState(true);

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
    isFeatured: null,
    published: null,
  });

  const headers = [
    { key: "title", header: "Title" },
    { key: "accountId", header: "Account" },
    { key: "isPublished", header: "Published" },
    { key: "isFeatured", header: "Featured" },
  ];

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      title: row.title,
      accountId: <CreativeRow row={row} />,
      isPublished: (
        <Tag
          type={
            row.status === STATUSES_UP.PUBLISHED
              ? BG_COLORS.GREEN
              : BG_COLORS.GRAY
          }
        >
          {row.status === STATUSES_UP.PUBLISHED
            ? IS_PUBLISHED.PUBLISHED
            : IS_PUBLISHED.UNPUBLISHED}
        </Tag>
      ),
      isFeatured: row?.isFeatured ? "Yes" : "No",
    };
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteProject(
        {
          projectIds: _items.map((v) => ({
            _id: v.id,
          })),
        },
        () => {
          fetch({
            query: "",
            page: 0,
            limit: paginationContent.limit,
            isFeatured: paginationContent.isFeatured,
            published: paginationContent.published,
          });
        }
      )
    );
  };

  const viewDetail = (_data) => {
    const projectId = _data[0].id.split(":")[0];
    history.push(`/projects/form/${projectId}`);
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
      isFeatured: paginationContent.isFeatured,
      published: paginationContent.published,
    });
  };

  const searchTable = debounce(async (e) => {
    const { value } = e.target;

    await fetch({
      query: value,
      page: 0,
      limit: paginationContent.limit,
      isFeatured: paginationContent.isFeatured,
      published: paginationContent.published,
    });
  }, 300);

  // const fetch = ({ query, page, limit, isFeatured, published }) => {
  //   console.info(isFeatured, published);
  //   dispatch(
  //     fetchAllProject(
  //       { query, page, limit, isFeatured, published },
  //       ({ filteredData, totalFiltered, total }) =>
  //   });
  // }, 300);

  const fetch = ({ query, page, limit, isFeatured, published }) => {
    setIsLoadingData(true);
    dispatch(
      fetchAllProject(
        { query, page, limit, isFeatured, published },
        ({ filteredData, totalFiltered, total }) => {
          setPaginationContent((v) => ({
            ...v,
            skip: totalFiltered,
            query,
            limit,
            page,
            total,
            isFeatured,
            published,
            totalItems: PageHelper.getTotalItems(total, limit),
            rows: filteredData.map(mapToColumn),
          }));
          setIsLoadingData(false);
        }
      )
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  const handleApplyFilter = ({ selectedItems }) => {
    fetch({
      ...paginationContent,
      isFeatured: selectedItems.some((item) => item.id === "featured") || null,
      published: selectedItems.some((item) => item.id === "published") || null,
    });
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  return (
    <UIShell breadcrumbs={[{ name: "Home", link: "/" }, { name: "Project" }]}>
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/projects/form")}
        viewDetail={viewDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
        title="Project List"
        description="All Projects from creatives"
        onApplyFilter={handleApplyFilter}
      />
    </UIShell>
  );
}

function CreativeRow({ row }) {
  const dispatch = useDispatch();
  const [creative, setCreative] = useState(undefined);

  useEffect(() => {
    dispatch(
      getAccount({ id: row.accountId }, (result) => {
        setCreative(result[0]);
      })
    );
  }, []);

  return (
    <span>
      {creative?.firstName} {creative?.lastName} | {creative?.email}
    </span>
  );
}

const mapStateToProps = (state) => {
  return {
    dataTableList: state.projectReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(ProjectPage);
